import React from 'react'

const LogoSmall = () => {
  return (
    <img src="/images/new-logo-small.png" alt="Logo" width={60} height={50} />
  )
}

export default LogoSmall